import { render, staticRenderFns } from "./EnemGrades.vue?vue&type=template&id=2a2d7a56&scoped=true&"
import script from "./EnemGrades.vue?vue&type=script&lang=ts&"
export * from "./EnemGrades.vue?vue&type=script&lang=ts&"
import style0 from "./EnemGrades.vue?vue&type=style&index=0&id=2a2d7a56&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2d7a56",
  null
  
)

export default component.exports